import type { RegisterRouteFunction, RouterOptions } from 'owa-router';
import { lazyInitializeMailRoutes, lazyGetCurrentRoute } from 'owa-mail-routing';
import { testIfRouteExists } from './testIfRouteExists';

export let mailRouterOptions: RouterOptions = {
    routeGenerator: lazyGetCurrentRoute.import(),
    vdir: 'mail',
    defaultRoute: '/',
    registerRoutes: initializeMailRoutes,
};

async function initializeMailRoutes(
    registerMailRoute: RegisterRouteFunction,
    registerAll?: boolean
) {
    const routesPromise = lazyInitializeMailRoutes.importAndExecute(registerMailRoute);

    // if a route exists then let's wait to download the routing logic
    if (testIfRouteExists() || registerAll) {
        await routesPromise;
    }
}
